import { DefaultTheme } from 'styled-components'

// WhatsApp Web Premium - Dark Mode
export const dark: DefaultTheme = {
  name: 'dark',
  colors: {
    primary: '#E9EDEF',
    secondary: '#111B21',
    alternativeSecodary: '#0B141A',
    tertiary: '#8696A0',
    surfaceBackground: '#00A884',
    accentColor: '#00A884',
    accentHover: '#00BD96',
    danger: '#EA5455',
    warning: '#FBBF24',
    tabs: '#00A884',
    borderColorPrimary: '#222D34',
    borderColorSecondary: '#2A3942',
    tooltipBackground: '#202C33',
    text: {
      primary: '#E9EDEF',
      secondary: '#D1D7DB',
      tertiary: '#8696A0',
      fourth: '#E9EDEF'
    },
    conversation: {
      bgReceived: '#202C33',
      bgSent: '#005C4B',
      textReceived: '#E9EDEF',
      textSent: '#E9EDEF',
      avatarBgSent: '#E9EDEF',
      avatarBgReceived: '#00A884'
    }
  },
  background: {
    primary: '#0B141A',
    secondary: '#111B21',
    tertiary: '#00A884',
    chat: '#0B141A',
    chatDeep: '#0B141A',
    input: '#202C33',
    inputField: '#2A3942'
  },
  borderColor: {
    primary: '#222D34',
    secondary: '#2A3942'
  },
  layers: {
    base: 10,
    menu: 20,
    overlay: 30,
    modal: 40,
    alwaysOnTop: 50
  },
  border: {
    radius: '8px'
  },
  font: {
    sizes: {
      title: {},
      body: {
        primary: '0.875rem'
      }
    },
    weight: {
      light: 300,
      normal: 400,
      medium: 500,
      semiBold: 600,
      bold: 700
    }
  },
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.15)',
    base: '0 2px 8px rgba(0, 0, 0, 0.20)',
    md: '0 4px 16px rgba(0, 0, 0, 0.25)',
    lg: '0 8px 32px rgba(0, 0, 0, 0.30)',
    xl: '0 16px 48px rgba(0, 0, 0, 0.35)'
  },
  spacings: {
    spacing_xs: '0.5rem',
    spacing_sm: '1rem',
    spacing_m: '1.5rem',
    spacing_lg: '2rem',
    spacing_xl: '3rem'
  },
  textMainPrimaryButton: '#FFFFFF',
  balonMessageIsReceived: '#202C33',
  balonMessageIsSent: '#005C4B',
  textLabelInputDrawer: '#E9EDEF',
  mode: 'dark'
}

// WhatsApp Web Premium - Light Mode
export const light: DefaultTheme = {
  name: 'light',
  colors: {
    primary: '#111B21',
    secondary: '#FFFFFF',
    alternativeSecodary: '#F0F2F5',
    tertiary: '#667781',
    surfaceBackground: '#00A884',
    accentColor: '#00A884',
    accentHover: '#00997A',
    danger: '#DC3545',
    warning: '#D97706',
    tabs: '#00A884',
    borderColorPrimary: '#E9EDEF',
    borderColorSecondary: '#D1D7DB',
    tooltipBackground: '#FFFFFF',
    text: {
      primary: '#111B21',
      secondary: '#3B4A54',
      tertiary: '#667781',
      fourth: '#FFFFFF'
    },
    conversation: {
      bgReceived: '#FFFFFF',
      bgSent: '#D9FDD3',
      textReceived: '#111B21',
      textSent: '#111B21',
      avatarBgSent: '#E9EDEF',
      avatarBgReceived: '#00A884'
    }
  },
  background: {
    primary: '#EFEAE2',
    secondary: '#FFFFFF',
    tertiary: '#00A884',
    chat: '#EFEAE2',
    chatDeep: '#EFEAE2',
    input: '#F0F2F5',
    inputField: '#FFFFFF'
  },
  borderColor: {
    primary: '#E9EDEF',
    secondary: '#D1D7DB'
  },
  layers: {
    base: 10,
    menu: 20,
    overlay: 30,
    modal: 40,
    alwaysOnTop: 50
  },
  border: {
    radius: '8px'
  },
  font: {
    sizes: {
      title: {},
      body: {
        primary: '0.875rem'
      }
    },
    weight: {
      light: 300,
      normal: 400,
      medium: 500,
      semiBold: 600,
      bold: 700
    }
  },
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.06)',
    base: '0 2px 8px rgba(0, 0, 0, 0.08)',
    md: '0 4px 16px rgba(0, 0, 0, 0.10)',
    lg: '0 8px 32px rgba(0, 0, 0, 0.12)',
    xl: '0 16px 48px rgba(0, 0, 0, 0.15)'
  },
  spacings: {
    spacing_xs: '0.5rem',
    spacing_sm: '1rem',
    spacing_m: '1.5rem',
    spacing_lg: '2rem',
    spacing_xl: '3rem'
  },
  textMainPrimaryButton: '#FFFFFF',
  balonMessageIsReceived: '#FFFFFF',
  balonMessageIsSent: '#D9FDD3',
  textLabelInputDrawer: '#111B21',
  mode: 'light'
}
